import {
	Button,
	Col,
	ColorPicker,
	Flex,
	Form,
	Input,
	Row,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
import { RollbackOutlined } from "@ant-design/icons";

const Strategy = ({ history, match }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	useEffect(() => {
		getStrategy();
	}, []);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const getStrategy = async () => {
		try {
			let url = api + `/strategy/get/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					...initialValues,
					name: payload.name,
					description: payload.description,
					color: payload.color,
				});
				setLoading(false);
				setLoadingForm(false);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get strategy");
			console.error(err.message);
			return null;
		}
	};

	const updateStrategy = async (data) => {
		setLoading(true);
		const strategy = {
			name: data.name,
			description: data.description,
			color: data.color,
		};

		try {
			const url = api + `/strategy/update/${match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, strategy);
			if (data.success) {
				openNotification("success", "Success", "Strategy updated");
				setTimeout(() => {
					setLoading(false);
					history.push("/strategy/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to update strategy",
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updateStrategy(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinish}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Description" name="description">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Color"
							name="color"
							rules={[
								{
									required: true,
									message: "Please select a color",
								},
							]}
							getValueFromEvent={(color) => color?.toHexString()}
						>
							<ColorPicker format="hex" showText />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	const goBack = () => {
		history.goBack();
	};

	return (
		<Layout title="Strategy" description="Edit Strategy" type="medium">
			{contextHolder}
			<Flex gap={"middle"} vertical>
				<Button
					type="primary"
					icon={<RollbackOutlined />}
					onClick={goBack}
					size="large"
				/>
				{loadingForm ? <CustomSpinner /> : <CustomForm />}
			</Flex>
		</Layout>
	);
};

export default Strategy;
